export default {
  payWelfareText: 'Benefícios de recarga',
  blackFridayDiscount: 'Desconto cronometrado da Black Friday',
  shareGift: 'Compartilhar Presente',
  vipWeeklyWelfare: 'Desconto Semanal VIP',
  exchangeCoupon: 'Cupom',
  firstPayOff: 'Até 15% de Desconto na 1ª compra',
  blackFridayEvent: 'Evento de Black Friday',
  limitedTimeOff: '10% de desconto por Tempo Limitado',
  claimCoupon: 'Resgate agora',
  blackFridayTimedCoupon: 'Cupom de Black Friday por tempo limitado',
  timeLeft: 'Tempo restante:',
  claimTimeCoupon: 'Solicite cupom de 10% de desconto agora!',
  points: 'Pontos: ${point}',
  costPointTip: 'Troque pontos por cupons',
  maxPointTip: 'Cada conta pode usar até 500 pontos.',
  discountOff: '10% DE DESCONTO',
  highestDiscount: 'ATÉ  ${discount} DE DESCONTO',
  needPoint: 'Requer ${point} pontos',
  changeCurrency: 'Alterar moeda',
  claim: 'Resgatar',
  claimSucc: 'Resgatado',
  claimFail: 'Falhou',
  pointNotEnough: 'Pontos insuficientes',
  afterClaimPoint: 'Pontos restantes: ${point}',
  footTips1: 'Apenas 1 cupom pode ser usado para cada pedido.',
  footTips2: 'O cupom não pode ser usado para comprar moedas/tokens no jogo.',
  footTips3: 'Reservamo-nos o direito da interpretação final deste evento.',
  ruleTitleText: 'Regras do Evento',
  ruleTime:
    'Duração do evento: 00h00 de 24 de novembro de 2023 até 23h59 de 26 de novembro de 2023 (UTC)',
  bfRuleText1:
    '1. 400 pontos serão concedidos à sua conta quando você fizer login na página oficial de recarga pela primeira vez durante o evento. Você pode trocar até 500 pontos por cupons.',
  bfRuleText2:
    '2. Você poderá trocar pontos da Black Friday por cupons durante o evento.',
  bfRuleText3:
    '3. Você só poderá utilizar 1 cupom por cada pedido. Os cupons não podem ser usados para comprar moedas/tokens no jogo.',
  bfRuleText4: '4. Para transações, aceitamos apenas as seguintes moedas:',
  ableCoinsType: '/',
  bfRuleText5:
    '5. Você não pode alterar a moeda após a transação ser realizada. Os pontos trocados não podem ser reembolsados.',
  bfRuleText6: '6. Os cupons da Black Friday serão válidos apenas por 7 dias.',
  bfRuleText7: '7. Reservamo-nos o direito da interpretação final deste evento.',
  thanksTip:
    'Obrigado pela sua participação. Participe da nossa comunidade oficial para obter mais informações sobre o evento.',
  exchangePoints: 'Trocar',
  exchangeCode: 'Insira o código de troca.',
  enterExchangeCode: 'Insira o código de troca.',
  exchangeText: 'Trocar',
  confirmGet: 'Confirmar',
  couponUsedWay:
    'O cupom só pode ser usado com moedas específicas. Confirme sua moeda.',
  confirmText: 'Confirmar',
  exchangeSucc: 'Trocado',
  aboutCoins: 'Sobre moedas/tokens no jogo',
  aboutCoinsText:
    'Você pode trocar moedas/tokens do jogo por todos os pacotes e privilégios, exceto pela própria moeda/token do jogo.',
  known: 'OK',
  codeText: 'Código',
  codeInvalid: 'Código inválido!',
  hasExchanged: 'Você não pode resgatar mais códigos.',
  hideText: 'Esconder',
  //黑五的报错码
  'bf-20001': 'Não logado',
  'bf-20002': 'Erro de parâmetro. Tente entrar novamente no evento.',
  'bf-20003': 'Pontos insuficientes',
  'bf-20004':
    'Falha. Tente novamente mais tarde ou entre em contato com o Suporte ao Cliente.',
  'bf-20005': 'Resgatado',
  'bf-20015': 'O evento não está disponível no momento.',
  'bf-20016': 'O evento terminou.',
  bfShareText: 'Solicite cupom de 10% de desconto agora!',
  rightsCenterBtn: 'Centro de Membros Premium',
  payBtn: 'RECARGA',
  hasEqualRewardMuglo: 'Até 1800 diamantes de BÔNUS na recarga do site oficial!',
  productInterceptPopupTitle: 'Purchase Failed',
  productInterceptPopupTip: 'This item is not available in your region.<br>Please contact customer support if you have any questions.',
  productInterceptPopupConfirm: 'OK',
  vipHeadAwardText285 : 'Extraordinário Glorioso (Permanente)',
  rightCenterNoticeTitle: 'Sistema de Pontos VIP está sendo atualizado para o Centro de Privilégios',
  rightCenterNoticeContent: 'Greetings, Commander!<br />Thank you for your supporting Puzzles & Survival. To bring you an even better rewards experience, the current VIP Point System will be upgraded to the all-new Premium Member Center on July 16, 2025. This new system will not only consolidate existing VIP benefits but also introduce a host of exciting new perks. Here\'s what you need to know:<br />1. What\'s Changing?<br />Weekly Log in Benefits Remain<br />From July 16 to 29, 2025, players can continue to claim Weekly VIP Coupons by logging in to the Official Top-up Page. The number of coupons will remain the same as in the VIP Point event. Meanwhile, players will also be able to redeem new coupons in the Premium Member Center, which will include a maximum discount cap. For more details on the new coupon rules and redemption limits, refer to the table at the end of this notice.<br />Note: The automatic coupon redemption feature must be manually enabled. To do so, go to: Privilege Center Homepage > Member Benefits > Enable Auto Redeem Coupons > Select Coupons to Auto-Redeem > Confirm.<br />New Points Exchange Feature<br />The Privilege Center will offer a Points Exchange feature. Earn points by logging in to the game or completing designated tasks. Points can be exchanged for exclusive coupons, rare items, and other valuable rewards. (See the Privilege Center page for item redemption limits.)<br />VIP Level Inheritance<br />Your current VIP level and accumulated VIP Points will be fully transferred to the new system. You\'ll automatically be assigned the corresponding Privilege Center tier, and all your current VIP benefits will be retained and further enhanced under the new system.<br />2. Why This Upgrade Is Better<br />Clearer Benefits: All reward rules and redemption details are clearly displayed, making it easier to claim your benefits.<br />Greater Rewards: Enjoy new point exchange events and regularly updated high-value items.<br />Lucky Draws: In addition to points exchange, prize draw events will also be available, giving you chances to win valuable in-game items.<br />3. Important Notes<br />During the transition period (July 16 to 29, 2025), the original VIP Points section will be gradually phased out. You will still be able to receive and use coupons as usual during this time. Be sure to use any remaining coupons before the VIP Points Event ends. Unused coupons will expire.<br />After the Privilege Center goes live, you can access it by going to Official Top-up Center > Tap Avatar > Privilege Center',
  rightCenterNoticeTableTitle: 'Comparação de alterações de cupom',
  rightCenterNoticeTableHeader1: 'Requisitos de Resgate - Nível de Associação Premium',
  rightCenterNoticeTableHeader2: 'Nível VIP original',
  rightCenterNoticeTableHeader3: 'Desconto do cupom',
  rightCenterNoticeTableHeader4: 'Limite de Aquisição',
  rightCenterNoticeTableHeader5: 'Limite Máximo de Desconto',
  rightCenterNoticeTableLevel1: 'Bronze',
  rightCenterNoticeTableLevel2: 'Prata',
  rightCenterNoticeTableLevel3: 'Ouro',
  rightCenterNoticeTableLevel4: 'Platina',
  rightCenterNoticeTableLevel5: 'Diamante',
  rightCenterNoticeTableCount1: 'Uma vez por dia',
  rightCenterNoticeTableCount2: '15 Vezes/Mês',
  rightCenterNoticeTableCount3: '10 Vezes/Mês',
  rightCenterNoticeTableLimit: '$15',
  rightCenterNoticeTableTip: 'Nota: Os limites de desconto de cupom no Centro de Privilégios são baseados em USD (Dólares) e podem variar com as taxas de câmbio. O valor real do desconto será exibido na página de uso.',
  '-': '-'
};
